'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.cloneArray = exports.indexOf = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /**
                                                                                                                                                                                                                                                                               * @fileoverview 数据相关
                                                                                                                                                                                                                                                                               * @author kirkzheng
                                                                                                                                                                                                                                                                               */

var _index = require('../object/index');

var _index2 = require('../type/index');

/**
 * 获得索引位置
 * @param  {Array} array 源数组
 * @param  {Any} value 对应的值
 * @return {Number}    索引
 */
var indexOf = exports.indexOf = function indexOf() {
    var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var value = arguments[1];

    var result = -1;

    if ((0, _index2.isArray)(array)) {
        array.map(function (item, index) {
            // 这里不采用===，因为就是就是一个宽松的indexOf
            if (typeof value !== 'undefined' && item == value) {
                result = index;
            }

            return item;
        });
    }

    return result;
};

/**
 * 深复制数组
 * @param  {Array} array 源数组
 * @param  {Any} value 对应的值
 * @return {Number}    索引
 */
var cloneArray = exports.cloneArray = function cloneArray(data) {
    var result = [];

    if ((0, _index2.isArray)(data)) {
        data.map(function (item) {
            if ((0, _index2.isArray)(item)) {
                result.push(cloneArray(item));
            } else if ((typeof item === 'undefined' ? 'undefined' : _typeof(item)) === 'object') {
                result.push((0, _index.objectAssign)(item));
            } else {
                result.push(item);
            }

            return item;
        });
    }

    return result;
};

exports.default = {
    indexOf: indexOf,
    cloneArray: cloneArray
};